<div class="toast-container">
  @for (toast of toastService.toasts$ | async; track toast.id) {
    <div 
      class="toast" 
      [class]="'toast-' + toast.type"
      @toastAnimation
    >
      <div class="toast-content">
        <div class="toast-icon">
          <i [class]="'bi ' + getIcon(toast.type)"></i>
        </div>
        <div class="toast-body">
          <p class="toast-title" *ngIf="toast.title">{{ toast.title }}</p>
          <p class="toast-message">{{ toast.message }}</p>
        </div>
        <button class="toast-close" (click)="removeToast(toast.id)">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="toast-progress" [style.animation-duration]="toast.duration + 'ms'"></div>
    </div>
  }
</div>
